import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Card from "../../../../components/Card";
import { formatDollarAmount } from "../../../../utils/methods";

interface PaymentKpiProps {
  kpis: any;
}

const PaymentKpi: React.FC<PaymentKpiProps> = ({ kpis }) => {
  const { t } = useTranslation();

  const { variant, icon }: { variant: any; icon: any } = useMemo(() => {
    switch (kpis?.payment_status) {
      case 'NO AMOUNT':
        return {
          variant: '',
          icon: 'ri-file-text-line ri-26px',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.noAmount')
        };
      case 'OVERPAID':
        return {
          variant: 'danger',
          icon: 'ri-check-double-line ri-26px',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.overpaid')
        };
      case 'PARTIAL PAID':
        return {
          variant: 'warning',
          icon: 'ri-time-line ri-26px',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.partialPaid')
        };
      case 'PAID':
        return {
          variant: 'success',
          icon: 'ri-check-line ri-26px',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.paid')
        };
      case 'OVERDUE':
        return {
          variant: 'danger',
          icon: 'ri-alert-line ri-26px',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.overdue')
        };
      default:
        return {
          variant: 'primary',
          icon: 'ri-file-text-line ri-26px',
          title: t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentStatus.noAmount')
        };
    }
  }, [kpis?.payment_status]);

  return (
    <div className="row g-4 mb-6">
      <div className="col-md-4">
        <Card
          title={t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.invoiceAmount')}
          value={formatDollarAmount(kpis?.invoice_amount || '0.00')}
          description={t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.invoiceAmountDesc')}
          icon="ri-file-text-line ri-26px"
          variant="primary"
          wrapperClassName=""
        />
      </div>
      <div className="col-md-4">
        <Card
          title={t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentAmount')}
          value={formatDollarAmount(kpis?.total_payment_amount || '0.00')}
          description={t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.paymentAmountDesc')}
          icon="ri-money-dollar-circle-line ri-26px"
          variant="success"
          wrapperClassName=""
        />
      </div>
      <div className="col-md-4">
        <Card
          // title={title}
          title={t('invoices.editPreviewPayment.pageTexts.form.paymentsTab.summary.amountDue')}
          value={formatDollarAmount(kpis?.outstanding_amount || '0.00')}
          description="&nbsp;"
          icon={icon}
          variant={variant}
          background
          wrapperClassName=""
        />
      </div>
    </div>
  );
};

export default PaymentKpi;
